// 公共的vuex管理
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import websocketApi from '@/api/websocketApi';
import userAPI from '@/api/user';

export default {
  // 初始化state
  state: {
    // 保证刷新后页面指示不重置
    pageIndex: parseInt(window.sessionStorage.getItem('pageIndex'), 10),
    loginInfo: JSON.parse(window.sessionStorage.getItem('loginInfo')),
    // 路由信息快照
    routerSnapshot: window.sessionStorage.getItem('routerSnapshot'),
    SOCKET: null,
    socketState: {
      // websockets的状态
      isConnected: false,
      // 连接完成后需要执行的函数
      onConnected: [],
    },
    otaResultArr: [],
    offLineDeviceId: '',
    onLineDeviceId: '',
    fullscreenStatus: false,
    //测试变量
    otaProgress:'0',
    otaSuccess:true,
    otaError:'',
    fileUploadProgress:new Map(),
  },
  // 获取state值，不直接获取state的原因是防止引用
  // 获取state方式：this.$store.getters.fnName
  getters: {
    // 第一次加载时无缓存，默认首页
    getPageIndex: state => (state.pageIndex % 1 === 0 ? state.pageIndex : 0),
    getLoginInfo: state => (state.loginInfo === null ? { success: false } : state.loginInfo),
    getRouterSnapshot: state => (state.routerSnapshot === null ? '/' : state.routerSnapshot),
    getOTAResultArr: state => state.otaResultArr,
    getOffLineDeviceId: state => state.offLineDeviceId,
    getOnLineDeviceId: state => state.onLineDeviceId,
    getFullscreenStatus: state => state.fullscreenStatus,
    getOTAProgress: state => state.otaProgress,
    getOTASuccess:state => state.otaSuccess,
    getOTAError:state => state.otaError,
    getFileUploadProgress:state=>state.fileUploadProgress,
  },
  // 改变state值
  // 调用方式：this.$store.commit(fnName, params)
  mutations: {
    setPageIndex(state, index) {
      state.pageIndex = index;
      window.sessionStorage.setItem('pageIndex', index);
    },
    setLoginInfo(state, obj) {
      state.loginInfo = obj;
      window.sessionStorage.setItem('loginInfo', JSON.stringify(obj));
    },
    // websockets连接完成之后需要执行的函数
    registerSocketOnConnect(state, func) {
      state.socketState.onConnected.push(func);
    },
    // 设置websocet状态
    setSocketStatus(state, re) {
      state.socketState.isConnected = re;
    },
    setRouterSnapshot(state, router) {
      state.routerSnapshot = router;
      window.sessionStorage.setItem('routerSnapshot', router);
    },
    setOTAResult(state, payload) {
      state.otaResultArr = payload;
    },
    setFullscreenStatus(state, payload) {
      state.fullscreenStatus = payload;
    },
    setOTAProgress(state,payload){
      state.otaProgress = payload;
    },
    setOTASuccess(state,payload){
      state.otaSuccess = payload;
    },
    setOTAError(state,payload){
      state.otaError = payload;
    },
    setFileUploadProgress(state,payload){
      state.fileUploadProgress=new Map(payload);
    }
  },
  // 用来处理异步执行，比如购物车同时计算之类的功能
  // 调用方式：this.$store.dispatch(fnName, params)
  actions: {
    /**
    *@Description: 校验登录信息
    *@Param: 验证结果对象
    *@Author: SUN Hao
    *@date: 2019/3/4
    */
    async confirmLoginInfo({ commit }, payload) {
      const { email: userName, pwd: password } = payload;
      await userAPI.verifyLogin(userName, password)
        .then((res) => {
          commit('setLoginInfo', { data: res, success: true });
          Promise.resolve(commit);
        })
        .catch((err) => {
          console.log(err);
          commit('setLoginInfo', { success: false, errorCode: err[0], errorMsg: err[1] });
        });
    },
    /**
     * 初始化websockets
     * @param state
     * @param dispatch
     * @param rootState
     * @param commit
     * @returns {Promise<boolean>}
     */
    async websocketConnect({
      state, rootState, commit,
    }) {
      // console.log('rootState', rootState);
      const s = new SockJS(websocketApi.WEBSOCKET_URL, null, {});
      state.SOCKET = Stomp.over(s);
      await state.SOCKET.connect({
        username: 'james',
        password: 'james',
        clientType: 'webclient',
      }, () => {
        console.log('websocket已连接');
        const url = websocketApi.DEVICE_OFFLINE;
        state.SOCKET.subscribe(url, (msg) => {
          const body = JSON.parse(msg.body);
          state.offLineDeviceId = body.id;
        });
        const onlineUrl = websocketApi.DEVICE_ONLINE;
        state.SOCKET.subscribe(onlineUrl, (msg) => {
          state.onLineDeviceId = msg.body;
        });
        commit('setSocketStatus', true);
        // console.log('list', state.socketState.onConnected);
        if (state.socketState.onConnected.length > 0) {
          const list = state.socketState.onConnected;
          list.forEach((item) => {
            item();
          });
        }
      });
      return true;
    },
    /**
     * 关闭websockets
     * @param state
     */
    websocketClose({ state, commit }) {
      console.log('websockets断开连接');
      state.SOCKET.disconnect(() => {
        console.log('后端websocket断开连接');
        // 将websockets的状态设为false
        commit('setSocketStatus', false);
      });
      commit('setSocketStatus', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/app.js